const DropArrowIcon = ({
  color = 'currentColor',
  className = 'dropdown-icon'
}) => {
  return (
    <svg
      width="10"
      height="6"
      className={className}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L9 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DropArrowIcon;
